import {
    ApiHandlerDiscreteParameter,
    createHandlerChainRunner,
    HasOnError,
    HasOnSuccess,
} from "@insite/client-framework/HandlerCreator";
import { CustomRMAUploadService, ReturnRMADataFiles } from "@tSurya/Services/CustomRMAImageUploadSerivie";

type SubmitCustomSubmitOrder = HasOnSuccess & ReturnRMADataFiles & HasOnError;

type CustomHandlerType = ApiHandlerDiscreteParameter<SubmitCustomSubmitOrder, ReturnRMADataFiles, any>;

const CustomPopulateApiParameter: CustomHandlerType = props => {
    props.apiParameter = {
        ...props.parameter,
    };
};

const CustomSendDataToApi: CustomHandlerType = async props => {
    const state = props.getState();
    const sageApiKey = state.context.settings.properties.sageAPIKeyforFilesAttachments;
    const returnUrl = state.context.settings.properties.sageAPIEndpointforFilesAttachments;
    try {
        const result = await CustomRMAUploadService(props.apiParameter, sageApiKey, returnUrl);
        props.apiResult = {
            success: true,
            result,
        };
    } catch (err) {
        props.apiResult = {
            success: false,
        };
    }
};

export const ExecuteOnSuccessCallback: CustomHandlerType = props => {
    if (props.apiResult.success) {
        props.parameter.onSuccess?.(props.apiResult);
    }
};

export const ExecuteOnErrorCallback: CustomHandlerType = props => {
    if (props.apiResult.error) {
        props.parameter.onError?.();
    }
};

export const chain = [
    CustomPopulateApiParameter,
    CustomSendDataToApi,
    ExecuteOnSuccessCallback,
    ExecuteOnErrorCallback,
];

const CustomRMAUpload = createHandlerChainRunner(chain, "CustomRMAUpload");
export default CustomRMAUpload;
